import { getBaseRole } from '@/helpers/customRoles';
import store from '../store/redux.store'
import rolesEnum from "@/constant/rolesEnum";

const roleActive = () => { 
    const role = store.getState().profile.profile.role;

    const adminActive = () => {
        if(getBaseRole(role) == rolesEnum.admin || getBaseRole(role) == rolesEnum.juniorAdmin) {
            return true;
        }
        return false;
    }

    const rolesActive = {
        admin: getBaseRole(role) == rolesEnum.admin,
        juniorAdmin: getBaseRole(role) == rolesEnum.juniorAdmin,
        adminPanel: getBaseRole(role) == rolesEnum.adminPanel,
        children: getBaseRole(role) == rolesEnum.children,
        parent: getBaseRole(role) == rolesEnum.parent,
        hrManager: getBaseRole(role) == rolesEnum.hrManager,
        htPanel: getBaseRole(role) == rolesEnum.htPanel,
        personalManager: getBaseRole(role) == rolesEnum.personalManager,
        seminarian: getBaseRole(role) == rolesEnum.seminarian,
        seniorSeminarian: getBaseRole(role) == rolesEnum.seniorSeminarian,
        adminOrjuniorAdmin: adminActive(),
        childrenOrParent: getBaseRole(role) == rolesEnum.children || getBaseRole(role) == rolesEnum.parent
    }

    return { adminActive, rolesActive }; 
};
export default roleActive;
